module.exports = __webpack_public_path__ + "static/media/2_offline.9ad00f72.png";